const DEFAULT_TRACKING_KEY = "FaqClimatempo";

const buildTrackingPayload = (trackingKey, index, eventName) => {
  const accordionName = `Accordion_${trackingKey}`;
  const questionNumber = String(index + 1).padStart(2, "0");

  return {
    event: eventName,
    id: `${accordionName}_Item_Questao-${questionNumber}`,
    name: accordionName,
  };
};

const renderFaqHead = () => {
  const faqItems = document.querySelectorAll(".home-faq__item");

  if (!faqItems.length) {
    return;
  }

  const faqData = Array.from(faqItems)
    .map((item) => {
      const questionElement = item.querySelector(".home-faq__question");
      const answerElement = item.querySelector(".home-faq__answer");

      if (!questionElement || !answerElement) {
        return null;
      }

      return {
        question: questionElement.textContent.trim(),
        answer: answerElement.innerHTML.trim(),
      };
    })
    .filter(Boolean)
    .slice(0, 5);

  if (!faqData.length) {
    return;
  }

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.text = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((faqItem) => ({
      "@type": "Question",
      name: faqItem.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faqItem.answer,
      },
    })),
  });

  document.head.appendChild(script);
};

const handleAnswerOpening = ({ trackingKey = DEFAULT_TRACKING_KEY } = {}) => {
  const faqItems = document.querySelectorAll(".home-faq__item");

  if (!faqItems.length) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  
  faqItems.forEach((item, index) => {
    const trigger = item.querySelector("[data-faq-trigger]");
    const panel = item.querySelector("[data-faq-panel]");
    
    if (!trigger || !panel) {
      return;
    }

    const applyState = (isOpen) => {
      item.classList.toggle("is-open", isOpen);
      panel.classList.toggle("is-open", isOpen);
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      panel.hidden = !isOpen;
    };

    const isInitiallyOpen = item.classList.contains("is-open");
    applyState(isInitiallyOpen);

    trigger.addEventListener("click", () => {
      const isOpen = !item.classList.contains("is-open");

      applyState(isOpen);

      window.dataLayer.push(
        buildTrackingPayload(
          trackingKey,
          index,
          isOpen ? "open_accordion" : "close_accordion"
        )
      );
    });
  });
};

const accordionFaqHome = {
  renderFaqHead,
  handleAnswerOpening,
};

export default accordionFaqHome;
